import { render, staticRenderFns } from "./study-bridge.vue?vue&type=template&id=e9792636&scoped=true&"
import script from "./study-bridge.vue?vue&type=script&lang=js&"
export * from "./study-bridge.vue?vue&type=script&lang=js&"
import style0 from "./study-bridge.vue?vue&type=style&index=0&id=e9792636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9792636",
  null
  
)

export default component.exports